import './index.css';

import { useEffect, useCallback } from 'react';

import { motion, AnimatePresence } from 'framer-motion';

import useMode from './stores/mode';
import useViewport from './hooks/useViewport';

import Header from './components/Header';
import { Navigation } from './components/Navigation';
import Intro from './components/Intro';
import AR from './components/AR';
import Item from './components/Item';
import Index from './components/Index';
import Notice from './components/Notice';

const transitions = {
    hidden: {
        x: 100,
        opacity: 0,
        transition: {
            ease: 'easeInOut',
            duration: 0.3,
        },
    },
    visible: {
        x: 0,
        opacity: 1,
        transition: {
            ease: 'easeInOut',
            duration: 0.3,
        },
    },

    exit: {
        x: -100,
        opacity: 0,
        transition: {
            ease: 'easeInOut',
            duration: 0.3,
        },
    },
};

function App() {
    const mode = useMode();
    const viewportSize = useViewport();

    useEffect(() => {
        if (document) {
            const vh = window.innerHeight / 100;
            document.documentElement.style.setProperty('--vh', vh + 'px');
        }
    }, [viewportSize]);

    const Main = useCallback(() => {
        switch (mode.mode) {
            case 'intro':
                return <Intro></Intro>;
                break;

            case 'ar':
                return <AR></AR>;
                break;

            case 'item':
                return <Item></Item>;
                break;

            case 'index':
                return <Index></Index>;
                break;
        }
    }, [mode.mode]);

    return (
        <div className={`App mode--${mode.mode}`}>
            <Header></Header>
            <Navigation></Navigation>
            <AnimatePresence initial={false} exitBeforeEnter={false}>
                <motion.div
                    key={mode.mode}
                    initial="hidden"
                    animate="visible"
                    exit="exit"
                    variants={transitions}
                    className="Main"
                >
                    {Main()}
                </motion.div>
            </AnimatePresence>

            <Notice></Notice>
        </div>
    );
}

export default App;
